import { render, staticRenderFns } from "./ModalHistoricoEndosso.vue?vue&type=template&id=1b3141ca&scoped=true"
import script from "./ModalHistoricoEndosso.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoEndosso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3141ca",
  null
  
)

export default component.exports